import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import Multiselect from 'vue-multiselect';
import ClientService from '../../../../services/clientmanagement.service';
import MasterService from './../../../../../masterdata/services/masterdata.service';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import xlsx from "xlsx";
import Util from './../../../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'otherinformation',
  components: {
    BasicSelect,
    Multiselect,
    VueElementLoading,
    Treeselect
  },
  props: ['clientData', 'productlist'],
  data() {
    return {
      isLoading: false,
      clientOtherInfoData: [],
      clientshortname: '',
      id: '',
      createdby: '',
      action: '',
      //for Product Accordion
      description: '',
      boxtypes: [],
      boxTypesData: [],
      productitem: {
        id: '',
        label: ''
      },
      productname: null,
      natureofgoods: [],
      othernatureofgoods: "",
      shipmentweight: null,
      productLoading: '',
      productdescription: '',
      damagerisk: '',
      flashpoint: '',
      isproductliquid: false,
      isproductfragile: false,
      productvalue: '',
      riskoftheft: '',
      ProjectedSalesData: [],
      expectedyield: '',
      checkedNames: [],
      uom:'',
      addBoxDimestion : [{
        "product" : '',
        "boxtype": null,
        "stackinglevel": '',
        "boxstrength": '',
        "length": '',
        "breadth": '',
        "height": '',
        "physicalweight": '',
        "hsn": '',
        "error":false
      }],
      disableAllFileds : false,
      annualcontractrevision : 0,
      revisionpercentage : '',
      useremail : '',
      userrole : '',
      userid : '',
      rolename : '',
      username : '',
      expanded:false,
			accordianTab:{1:false, 2:false, 3:false, 4:false, 5:false, 6:false,7:false},
      approvesend : false,
      inches:null,
      cm:null,
      convertermodal:false,
      categoryNameList: [],
      selectedCategory: null,
      isfranchisee:0
    }
  },
  computed: {},
  async mounted() {
    //console.log("clientData", this.clientData);
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail.email;
    this.useremail = userdetail.email;
    this.rolename = userdetail.rolename[0];
    this.username = userdetail.username;
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.userid = parseInt(userdetail.userid);

    if(this.productlist.length==0){
      await this.getProductCategoryList();
    }
    await this.getAllBoxTypes();
    if (this.clientData.ClientBusinessAccountId != '') {
      if (this.clientData.ClientShortName.toLowerCase().includes("franchise")){
        this.isfranchisee = 1;
        this.checkedNames = [ "APIIntegration" ];
      }
      await this.getClientOtherInfoList();
      await this.getClientHirarchInfo(this.clientData.ClientBusinessAccountId);
    } else {
      this.ProjectedSalesData = await this.getNext12MonthNamesWithYear()
      for (var i = 0; i < this.ProjectedSalesData.length; i++) {
        this.ProjectedSalesData[i].projectedsales = '';
      }
    }
  },
  methods: {
      handleTab(tabid){
        for (var key in this.accordianTab) {
          if(tabid = key){
            this.accordianTab[key] = false;
          }
          if(tabid = 1){
            this.accordianTab[2] = true;
          }
        }
      },
      handleTab1(tabid){
        for (var key in this.accordianTab) {
          if(tabid = key){
            this.accordianTab[key] = false;
          }
          if(tabid = 2){
            this.accordianTab[3] = true;
          }
        }
      },
    handleTab2(tabid){
      for (var key in this.accordianTab) {
        if(tabid = key){
          this.accordianTab[key] = false;
        }
        if(tabid = 3){
          this.accordianTab[4] = true;
        }
      }
    },
    handleTab3(tabid){
      for (var key in this.accordianTab) {
        if(tabid = key){
          this.accordianTab[key] = false;
        }
        if(tabid = 4){
          this.accordianTab[5] = true;
        }
      }
    },
    handleTab4(tabid){
      for (var key in this.accordianTab) {
        if(tabid = key){
          this.accordianTab[key] = false;
        }
        if(tabid = 5){
          this.accordianTab[6] = true;
        }
      }
    },
    handleTab5(tabid){
      for (var key in this.accordianTab) {
        if(tabid = key){
          this.accordianTab[key] = false;
        }
      }
    },
    isNumber: function(evt) {
    	evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
    expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
      this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
    async getClientHirarchInfo(clientid){
      let payload = {
        clientid : clientid,
        roleID : this.userrole,
        userID : this.userid,
        objectType : 'client'
      }
     let result = await ClientService.getClientInfoExist(payload);
     if (result.data.data.data.length > 0) {
       this.disableAllFileds = true;
     }
     if (result.data.data.edit == true) {
       this.approvesend = true;
     }else {
       this.approvesend = false;
     }
   },
    async getNext12MonthNamesWithYear() {
        let curdate = Util.getCurrentDate();
        var now = new Date(curdate);
        var year = now.getFullYear();
        var month = now.getMonth();
        var names = ['January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];
        var res = [];
        for (var i = 0; i < 12; ++i) {
            let obj = {
              "month": names[month],
              "year": year
            }
            res.push(obj);
            if (++month === 12) {
                month = 0;
                ++year;
            }
        }
        return res;
    },
    async getClientOtherInfoList() {
      try {
        this.isLoading = true
        let inputPayload = {
          clientid: this.clientData.ClientSystemID,
          clientbusinessaccountid: this.clientData.ClientBusinessAccountId
        }
        let result = await ClientService.getClientOtherInfoList(inputPayload);
        if (result.data.code == 200) {
          this.clientOtherInfoData = result.data.data;
          console.log("clientOtherInfoData",this.clientOtherInfoData);
          this.action = 'edit';
          await this.getRowData();
          if (this.clientOtherInfoData.cbid) {
            await this.getCategoryDataForPortToPort()
            if (this.clientOtherInfoData.ratetemplate) {
              this.selectedCategory = this.categoryNameList.find(x => x.id == this.clientOtherInfoData.ratetemplate)
            }
          }
        } else {
          this.action = ''
          this.clientOtherInfoData = [];
          this.ProjectedSalesData = await this.getNext12MonthNamesWithYear()
          for (var i = 0; i < this.ProjectedSalesData.length; i++) {
            this.ProjectedSalesData[i].projectedsales = '';
          }
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    //for Product Accordion
    async getProductCategoryList() {
      let tempproductList = [];
      this.productlist = [];
      try {
        this.productLoading = 'Loading Product...'
        this.isLoading = true;
        let result = await ClientService.getProductCategoryList();
        this.isLoading = false;
        let tempproductList = result.data.data;
        this.productLoading = '';
        for (var i = 0; i < tempproductList.length; i++) {
          this.productlist.push({
            'id': tempproductList[i].value,
            'label': tempproductList[i].text
          })
        }
      } catch (err) {
        this.productLoading = ''
        this.isLoading = false;
      }
    },
    setname(id, name){
      return name+id;
    },
    checkBoxType(index){
      this.setBoxTypeValues(index);
      this.checkProductField(index)
    },
    addNewRow(index) {
      this.addBoxDimestion.push({
        "product" : '',
        "boxtype": null,
        "stackinglevel": '',
        "boxstrength": '',
        "length": '',
        "breadth": '',
        "height": '',
        "physicalweight": '',
        "hsn": '',
        "error":false
        });
    },
    deleteRow(index) {
      this.$confirm("Remove selected Box Dimension Row.",'','question').then(()=>{
        this.addBoxDimestion.splice(index, 1);
      });
    },
    async getRowData() {
      this.addBoxDimestion = [];
      if(this.clientOtherInfoData){
        this.clientid = this.clientOtherInfoData.clientid;
        this.clientshortname = this.clientOtherInfoData.clientname;
        this.id = this.clientOtherInfoData.id;
        this.natureofgoods = this.clientOtherInfoData.natureofgoods != null ? this.clientOtherInfoData.natureofgoods : [];
        this.shipmentweight = this.clientOtherInfoData.avgshipmentwt != null ? this.clientOtherInfoData.avgshipmentwt : '';
        this.damagerisk = (this.clientOtherInfoData.damagerisk == 1 || this.clientOtherInfoData.damagerisk == 2) ? this.clientOtherInfoData.damagerisk : '';
        this.flashpoint = this.clientOtherInfoData.flashpoint != null ? this.clientOtherInfoData.flashpoint : 0;
        this.isproductliquid = this.clientOtherInfoData.isliquid == 1 ? true : false;
        this.isproductfragile = this.clientOtherInfoData.isfragile == 1 ? true : false;
        this.productvalue = this.clientOtherInfoData.productvalue;
        this.productdescription = this.clientOtherInfoData.describeother;
        this.othernatureofgoods = this.clientOtherInfoData.natureofgoodsothers;
        this.riskoftheft = this.clientOtherInfoData.riskoftheft;
        if (this.clientOtherInfoData.yearlysalesprojection != null) {
          for (var j = 0; j < this.clientOtherInfoData.yearlysalesprojection.length; j++) {
            this.ProjectedSalesData.push({
              "month": this.clientOtherInfoData.yearlysalesprojection[j].month,
              "year": this.clientOtherInfoData.yearlysalesprojection[j].year,
              "projectedsales": this.clientOtherInfoData.yearlysalesprojection[j].sales
            })
          }
        } else {
          this.ProjectedSalesData = await this.getNext12MonthNamesWithYear();
          for (var i = 0; i < this.ProjectedSalesData.length; i++) {
            this.ProjectedSalesData[i].projectedsales = '';
          }
        }
        this.checkedNames = this.clientOtherInfoData.manifestdatauploadmethod != null ? this.clientOtherInfoData.manifestdatauploadmethod : [];
        this.expectedyield = this.clientOtherInfoData.expectedyield != null ? this.clientOtherInfoData.expectedyield : '';
        this.annualcontractrevision = this.clientOtherInfoData.isannualcontractrevision != null ? this.clientOtherInfoData.isannualcontractrevision : 0;
        this.revisionpercentage = this.clientOtherInfoData.revisionpercentage != null ? this.clientOtherInfoData.revisionpercentage : null;
        if (this.clientOtherInfoData.productcategories && this.clientOtherInfoData.productcategories.length > 0) {
          this.productname = this.clientOtherInfoData.productcategories;
        }

        this.uom = this.clientOtherInfoData.uom;
        if (this.clientOtherInfoData.clientotherinfoboxdimentions != undefined && this.clientOtherInfoData.clientotherinfoboxdimentions.length > 0) {
          for (var i = 0; i < this.clientOtherInfoData.clientotherinfoboxdimentions.length; i++) {
            let obj = {
              "product" : this.clientOtherInfoData.clientotherinfoboxdimentions[i].productcategory,
              'productcategoryid': this.clientOtherInfoData.clientotherinfoboxdimentions[i].productcategory,
              "boxtype": this.clientOtherInfoData.clientotherinfoboxdimentions[i].boxtype,
              "stackinglevel": this.clientOtherInfoData.clientotherinfoboxdimentions[i].stackinglevel,
              "boxstrength": this.clientOtherInfoData.clientotherinfoboxdimentions[i].boxstrength,
              "length": this.clientOtherInfoData.clientotherinfoboxdimentions[i].dimension.L,
              "breadth": this.clientOtherInfoData.clientotherinfoboxdimentions[i].dimension.B,
              "height": this.clientOtherInfoData.clientotherinfoboxdimentions[i].dimension.H,
              "physicalweight": this.clientOtherInfoData.clientotherinfoboxdimentions[i].avgphysicalwt,
              "hsn": this.clientOtherInfoData.clientotherinfoboxdimentions[i].hsn,
              "errror":false
            }
            if (this.clientOtherInfoData.clientotherinfoboxdimentions[i].otherinfoid) {
              obj.otherinfoid = this.clientOtherInfoData.clientotherinfoboxdimentions[i].otherinfoid;
            }
            this.addBoxDimestion.push(obj);
          }
        } else {
          this.addBoxDimestion.push({
            "product" : '',
            "boxtype": null,
            "stackinglevel": '',
            "boxstrength": '',
            "length": '',
            "breadth": '',
            "height": '',
            "physicalweight": '',
            "hsn": '',
            "error":false
          });
        }
      }else{
        this.ProjectedSalesData = await this.getNext12MonthNamesWithYear();
        for (var i = 0; i < this.ProjectedSalesData.length; i++) {
          this.ProjectedSalesData[i].projectedsales = '';
        }
        this.addBoxDimestion.push({
          "product" : '',
          "boxtype": null,
          "stackinglevel": '',
          "boxstrength": '',
          "length": '',
          "breadth": '',
          "height": '',
          "physicalweight": '',
          "hsn": '',
          "error":false
        });
      }
    },
    async resetForm() {
      this.productname = null,
      this.natureofgoods = [],
      this.shipmentweight = null,
      this.damagerisk = '',
      this.flashpoint = '',
      this.isproductliquid = false,
      this.isproductfragile = false,
      this.productvalue = '',
      this.riskoftheft = '',
      this.expectedyield = '',
      this.annualcontractrevision = 0,
      this.revisionpercentage = null,
      this.checkedNames = []
      this.productdescription = ""
      this.$validator.reset()
      this.ProjectedSalesData = await this.getNext12MonthNamesWithYear()
      for (var i = 0; i < this.ProjectedSalesData.length; i++) {
        this.ProjectedSalesData[i].projectedsales = '';
      }
    },
    async checkProductType(productID,count){
      for (var j = 0; j < this.addBoxDimestion.length; j++) {
        if (this.addBoxDimestion[j].product == productID) {
            count ++;
            return count;
        }
      }
      return count;
    },
    saveProductDetails(){
      this.$validator.validateAll("productdetailsform").then((result) => {
        if(result){
          this.saveClientOtherInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveSaftyDetails(){
      this.$validator.validateAll("saftydetailsform").then((result) => {
        if(result){
          this.saveClientOtherInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveSecurityDetails(){
      this.$validator.validateAll("securitydetailsform").then((result) => {
        if(result){
          this.saveClientOtherInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },checkProductField(index){
        if(this.addBoxDimestion[index].product || this.addBoxDimestion[index].boxtype || this.addBoxDimestion[index].length
          || this.addBoxDimestion[index].breadth || this.addBoxDimestion[index].height || this.addBoxDimestion[index].hsn){
          this.addBoxDimestion[index].error = true
        }else{
          this.addBoxDimestion[index].error = false
        }
      },
    saveBoxDetails(){
      this.$validator.validateAll("boxdetailsform").then((result) => {
        if(result){
          this.saveClientOtherInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveCommercialDetails(){
      this.$validator.validateAll("commercialdetailsform").then((result) => {
        if(result){
          this.saveClientOtherInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveMenifestDetails(){
      this.$validator.validateAll("menifestdetailsform").then((result) => {
        if(result){
          this.saveClientOtherInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveClientOtherInformations(){
      if(this.expanded){
        this.saveAndNext('save');
      }else{
        let selectedflag = 0;
        for (var key in this.accordianTab) {
          if(this.accordianTab[key]==true){
            if(key==1){
              selectedflag = 1;
              this.saveProductDetails();
            }else if(key==2){
              selectedflag = 1;
              this.saveSaftyDetails();
            }else if(key==3){
              selectedflag = 1;
              this.saveSecurityDetails();
            }else if(key==4){
              selectedflag = 1;
              this.saveBoxDetails();
            }else if(key==5){
              selectedflag = 1;
              this.saveCommercialDetails();
            }else if(key==6){
              selectedflag = 1;
              this.saveMenifestDetails();
            }
          }
        }
        if(selectedflag==0){
          this.saveAndNext('save');
        }
      }
    },
    async saveClientOtherInfo(actiontype) {
      this.isLoading = true;
      var inputPayload = {};
      inputPayload.clientid = this.clientData.ClientSystemID;
      inputPayload.clientbusinessaccountid = this.clientData.ClientBusinessAccountId;
      inputPayload.clientname = this.clientData.ClientShortName;
      inputPayload.createdby = this.createdby;

      if(this.productname.length > 0 && this.natureofgoods.length > 0){
        inputPayload.productInfo = {};
        inputPayload.productInfo.productcategories = this.productname;
        inputPayload.productInfo.natureofgoods = this.natureofgoods;
        inputPayload.productInfo.othernatureofgoods = this.othernatureofgoods;
        inputPayload.productInfo.avarageshipmentwt = this.shipmentweight || null;
        inputPayload.productInfo.otherproductcategories = this.productdescription;
      }

      if(this.damagerisk){
        inputPayload.safetyInfo = {};
        inputPayload.safetyInfo.damagerisk = parseInt(this.damagerisk);
        inputPayload.safetyInfo.isproductfragile = this.isproductfragile == true ? 1 : 0;
        inputPayload.safetyInfo.isproductliquid = this.isproductliquid == true ? 1 : 0;
        inputPayload.safetyInfo.flashpoint = this.isproductliquid == true ? this.flashpoint : 0;
      }

      if(this.riskoftheft!="" && this.productvalue!=""){
        inputPayload.securityinfo = {};
        inputPayload.securityinfo.riskoftheft = parseInt(this.riskoftheft);
        inputPayload.securityinfo.productvalue = this.productvalue;
      }

      if(this.uom!="" && this.addBoxDimestion.length > 0){
        inputPayload.boxDimensionInfo = {};
        inputPayload.boxDimensionInfo.uom = this.uom;
        var boxdetails = [];
        for (var i = 0; i < this.addBoxDimestion.length; i++) {
          if(this.addBoxDimestion[i].product){
            boxdetails.push({
              "product": this.addBoxDimestion[i].product,
              "boxtype": this.addBoxDimestion[i].boxtype,
              "stackinglevel": this.addBoxDimestion[i].stackinglevel,
              "boxstrength": this.addBoxDimestion[i].boxstrength,
              "averagephysicalwt": this.addBoxDimestion[i].physicalweight,
              "hsn": this.addBoxDimestion[i].hsn,
              "dimensions": {
                "L": this.addBoxDimestion[i].length,
                "B": this.addBoxDimestion[i].breadth,
                "H": this.addBoxDimestion[i].height
              }
            })
          }
        }
        inputPayload.boxDimensionInfo.boxDimension = boxdetails;
      }

      if(this.expectedyield!="" && this.ProjectedSalesData.length > 0){
        inputPayload.commercialProjections = {};
        var projectsalesdetails = [];
        for (var x = 0; x < this.ProjectedSalesData.length; x++) {
          var salesdata = {
            "month": this.ProjectedSalesData[x].month,
            "year": this.ProjectedSalesData[x].year,
            "sales": this.ProjectedSalesData[x].projectedsales
          };
          projectsalesdetails.push(salesdata)
        }
        inputPayload.commercialProjections.yearlysalesprojection = projectsalesdetails;
        inputPayload.commercialProjections.expectedyield = this.expectedyield;
        inputPayload.commercialProjections.annualcontractrevision = this.annualcontractrevision;
        inputPayload.commercialProjections.revisionpercentage = this.revisionpercentage;
      }

      if(this.checkedNames.length > 0){
        inputPayload.manifestMethod = {};
        inputPayload.manifestMethod.manifestdatauploadmethod = this.checkedNames;
      }

      let result = await ClientService.saveOtherInformation(inputPayload);
      this.isLoading = false;
      if (result.data.code == 200) {
        let lastDateModiefyData = {
          clientSystemID : this.clientData.ClientSystemID
        }
        ClientService.updateLastModifiedDate(lastDateModiefyData);
        this.$alert(result.data.message, this.clientData.ClientShortName, "success");
        if(actiontype=='saveandnext'){
          this.$emit(`goBackToParent2`);
        }
      }else {
        this.$alert(result.data.message, this.clientData.ClientShortName, "error");
      }
    },
    async saveAndNext(actiontype) {
      let productdetailsform =  await this.$validator.validateAll("productdetailsform").then((result) => { return result});
      let saftydetailsform =  await this.$validator.validateAll("saftydetailsform").then((result) => { return result});
      let securitydetailsform =  await this.$validator.validateAll("securitydetailsform").then((result) => { return result});
      let boxdetailsform =  await this.$validator.validateAll("boxdetailsform").then((result) => { return result});
      let commercialdetailsform =  await this.$validator.validateAll("commercialdetailsform").then((result) => { return result});
      let menifestdetailsform =  await this.$validator.validateAll("menifestdetailsform").then((result) => { return result});

      if(!productdetailsform){ this.accordianTab[1] = true; }else{ this.accordianTab[1] = false; }
      if(!saftydetailsform){ this.accordianTab[2] = true; }else{ this.accordianTab[2] = false; }
      if(!securitydetailsform){ this.accordianTab[3] = true; }else{ this.accordianTab[3] = false; }
      if(!boxdetailsform){ this.accordianTab[4] = true; }else{ this.accordianTab[4] = false; }
      if(!commercialdetailsform){ this.accordianTab[5] = true; }else{ this.accordianTab[5] = false; }
      if(!menifestdetailsform){ this.accordianTab[6] = true; }else{ this.accordianTab[6] = false; }

      if(productdetailsform && saftydetailsform && securitydetailsform && boxdetailsform && commercialdetailsform && menifestdetailsform){
        this.saveClientOtherInfo(actiontype);
      }
    },
    async sendForApprove(){
      let payload = {
        clientid : this.clientData.ClientSystemID,
        clientbusinessaccountid : this.clientData.ClientBusinessAccountId
      }
      this.isLoading = true;
      let resultclientInfo = await ClientService.getclientinfo(payload);
      this.isLoading = false;
      if (resultclientInfo.data.data.clientotherinfo == 1 && resultclientInfo.data.data.clientkyc == 1 && resultclientInfo.data.data.contracts == 1) {
        this.$confirm(`Do you want to send ${this.clientData.ClientShortName} for approval ?`,'Client Other Information','question').then(async (result) => {
          if (result) {
            let payload ={
              objectType : 'client',
              clientID : this.clientData.ClientBusinessAccountId,
              clientShortName : this.clientData.ClientShortName,
              createdby : this.useremail,
              roleID : this.userrole,
              userID : this.userid,
              rolename : this.rolename,
              username : this.username
            }
            this.isLoading = true;
            let approvalResult =  await ClientService.sendForApproveInKYC(payload)
            this.isLoading = false;
            this.$alert(`${approvalResult.data.message}`,"Client Other Information","success");
            this.$emit("goBackToParent");
          }
        }).catch(e =>{
          this.isLoading = false;
          this.$alert('Client Approve Request Cancel',"Client Other Information","error");
        });
      }else {
        this.$alert('Please Enter All Mandatory Field Of Client KYC, Other Information & Contract',"Client Approval","error");
      }
    },
    async getAllBoxTypes(){
      try {
        this.isLoading = true;
        let InputPayload = {};
        let result = await MasterService.getAllBoxTypes(InputPayload);
        let tempBoxtypes = result.data.data;
        let boxtype = [];
        for (var i = 0; i < tempBoxtypes.length; i++) {
          let isdisabled = false;
          if(tempBoxtypes[i].status==0){
            isdisabled = true;
          }else{
            boxtype.push(tempBoxtypes[i]);
          }
          this.boxTypesData.push({
            'id': tempBoxtypes[i].boxtype,
            'label': tempBoxtypes[i].boxtype,
            'isDisabled': isdisabled
          })
        }
        this.boxtypes = boxtype;
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    getBoxTypeDetails(boxtype) {
      for (var i = 0; i < this.boxtypes.length; i++) {
        if (this.boxtypes[i].boxtype == boxtype) {
          return this.boxtypes[i];
        }
      }
    },
    setBoxTypeValues(index){
      if(this.addBoxDimestion[index].boxtype!=null){
        let boxtypedetail = this.getBoxTypeDetails(this.addBoxDimestion[index].boxtype);
        this.addBoxDimestion[index].stackinglevel = boxtypedetail.stackinglevel;
        this.addBoxDimestion[index].boxstrength = boxtypedetail.boxstrength;
      }else{
        this.addBoxDimestion[index].stackinglevel = "";
        this.addBoxDimestion[index].boxstrength = "";
      }
    },
    async checkForClientName(data){
      let clientNameCheckFlag = 0;
      for (var i = 0; i < data.length; i++) {
        if(this.clientData.ClientShortName!=data[i].ClientShortName.trim()){
          clientNameCheckFlag = 1;
          break;
        }
      }
      if(clientNameCheckFlag==1){
        return false;
      }else{
        return true;
      }
    },
    async uploadBoxData(e){
      this.isLoading = true;
      if(this.clientData.ClientSystemID=="" ||  this.clientData.ClientSystemID==null){
        this.isLoading = false;
        this.$alert('Please save client details first.', "", "error");
        return false;
      }

      let tempArr = this.addBoxDimestion;
      if(this.addBoxDimestion.length==1 && this.addBoxDimestion[0].product==""){
        this.addBoxDimestion = [];
      }

      const files = e.target.files;
      if (!files.length) {
        this.isLoading = false;
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.isLoading = false;
        return this.$alert('The upload format is incorrect. Please upload xls or xlsx format', "", "error");
      }
      const fileReader = new FileReader();
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = [];  // Clear received data
          let checkflag = await this.checkForClientName(ws);
          if(checkflag){
            for (var i = 0; i < ws.length; i++) {
              let boxtypedetail = this.getBoxTypeDetails(ws[i].TypeofBox.trim());
              let boxtype;
              let stackinglevel;
              let boxstrength;
              if(boxtypedetail!=undefined){
                boxtype = ws[i].TypeofBox;
                stackinglevel = boxtypedetail.stackinglevel;
                boxstrength = boxtypedetail.boxstrength;
              }else{
                boxtype = null;
                stackinglevel = "";
                boxstrength = "";
              }
              this.addBoxDimestion.push({
                "product" : ws[i].Product.trim(),
                "boxtype": boxtype,
                "stackinglevel": stackinglevel,
                "boxstrength": boxstrength,
                "length": ws[i].Length,
                "breadth": ws[i].Breadth,
                "height": ws[i].Height,
                "physicalweight": ws[i].Weight,
                "hsn": ws[i].HSN
              });
            }
          }else{
            this.addBoxDimestion = tempArr;
            this.isLoading = false;
            this.$alert('Client Short Name not matched.', "", "error");
            return false;
          }
        } catch (e) {
          this.isLoading = false;
          this.addBoxDimestion = tempArr;
          return this.$alert('Read failure!', "", "error");
        }
      };
      fileReader.readAsBinaryString(files[0]);
      this.isLoading = false;
    },
    downloadSampleFile(){
      var link = document.createElement('a');
      link.href = "../static/Sample_Box_Data.xlsx";
      link.setAttribute('target','_blank');
      link.remove();
      return true;
    },
    inchtocm(){
      this.cm = this.inches * 2.54;
    },
    cmtoinch(){
      this.inches = this.cm / 2.54
    },
    openConverter(){
     this.convertermodal=true;
  },
    closeConverter(){
    this.convertermodal=false;
  },
  async getCategoryDataForPortToPort() {
    try {
      this.isLoading = true;
      let inputPayload = {
        // "offset": this.offset,
        // "limit": this.pageLimit,
      }
      let result = await MasterService.GetCategoryListingAndVersionDetails(inputPayload)
      console.log("result", result);
      if (result.data.code == 200) {
        result.data.data.forEach(el => {
          this.categoryNameList.push({
            'id': el.id,
            'label': el.categoryname
          })
        })
      } else {
        this.$alertify.error(result.data.message)
      }
      this.isLoading = false;
    } catch (err) {
      console.log(err);
      this.isLoading = false;
    }
  },
  async saveCategoryDataForPortToPort() {
    try {
      this.isLoading = true;
      let inputPayload = {
        clientid: this.clientData.ClientSystemID,
        clientbusinessaccountid: this.clientData.ClientBusinessAccountId,
        ratetemplateid : this.selectedCategory.id
      }
      let result = await MasterService.SaveCategoryTemplateForClient(inputPayload)
      console.log("result", result);
      if (result.data.code == 200) {
        this.$alertify.success(result.data.message)
      } else {
        this.$alertify.error(result.data.message)
      }
      this.isLoading = false;
    } catch (err) {
      console.log(err);
      this.isLoading = false;
    }
  },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/addclient/otherinformation/otherinformation.js